import React from 'react';
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import './tabs.css';
import Notifications2 from '../tables/notifications';
import Results from '../tables/results';
import Messages from '../tables/messages';

import { useSelector, useDispatch } from 'react-redux';
import { setActiveTab } from '../../redux/panelPositionsSlice';

export const MiscTabs = () => {
    const dispatch = useDispatch();
    const userId = useSelector(state => state.globals.tsUserId);

    const savedTab = useSelector(state =>
        state.panelPositions.panelLayouts?.[userId]?.['MiscTabs']?.activeTab
    );

    const tabCount = 3;

    const safeIndex =
        savedTab !== undefined && savedTab < tabCount
            ? savedTab
            : 0;

    return (
        <div className="data-tabs">
            <Tabs
                key={`${userId}-${tabCount}`} // keeps consistency with others
                forceRenderTabPanel={true}
                className="Tabs"
                selectedIndex={safeIndex}
                onSelect={(index) => {
                    dispatch(setActiveTab({
                        userId,
                        panelId: 'MiscTabs',
                        tabId: index
                    }));
                }}
            >
                <TabList>
                    <Tab>Debug</Tab>
                    <Tab>Results</Tab>
                    <Tab>Notifications</Tab>
                </TabList>

                <TabPanel>
                    <Messages/>
                </TabPanel>
                <TabPanel>
                    <Results/>
                </TabPanel>
                <TabPanel>
                    <Notifications2/>
                </TabPanel>
            </Tabs>
        </div>
    );
};